import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

function MarketingSignup() {
  const [enabled, setEnabled] = useState(false);
  const [email, setEmail] = useState("");
  const [consent, setConsent] = useState(false);
  const [done, setDone] = useState(false);
  useEffect(() => { api.marketingConfig().then((c) => setEnabled(!!c.optin_enabled)).catch(() => setEnabled(false)); }, []);
  if (!enabled) return null;
  const submit = async (e) => {
    e.preventDefault();
    if (!consent) return toast.error("Please tick the box to receive marketing emails.");
    try { await api.marketingSubscribe(email, consent); setDone(true); toast.success("Subscribed — thanks!"); }
    catch (err) { toast.error(err?.response?.data?.detail || "Could not subscribe."); }
  };
  return (
    <div className="mb-8 rounded-2xl border border-white/10 bg-white/[0.02] p-5" data-testid="marketing-signup">
      <div className="font-display text-lg font-bold text-white">Get Caption Motion updates</div>
      {done ? <p className="mt-2 text-sm text-[#22c55e]">You're subscribed. Watch your inbox for new features and offers.</p> : (
        <form onSubmit={submit} className="mt-3 space-y-2">
          <div className="flex flex-col gap-2 sm:flex-row">
            <input data-testid="marketing-signup-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com" className="flex-1 rounded-lg border border-white/10 bg-white/[0.03] px-3 py-2 text-sm text-white outline-none focus:border-[#00F0FF]/50" />
            <button data-testid="marketing-signup-submit" type="submit" className="rounded-lg bg-[#00F0FF] px-4 py-2 text-sm font-bold text-black">Subscribe</button>
          </div>
          <label className="flex items-start gap-2 text-xs text-[#A1A1AA]">
            <input data-testid="marketing-signup-consent" type="checkbox" checked={consent} onChange={(e) => setConsent(e.target.checked)} className="mt-0.5" />
            <span>I would like to receive marketing emails from Caption Motion about new features, tools, updates and offers. You can unsubscribe anytime.</span>
          </label>
        </form>
      )}
    </div>
  );
}

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-[#0A0A0A]" data-testid="footer">
      <div className="mx-auto max-w-6xl px-5 py-10">
        <MarketingSignup />
        <div className="flex flex-col items-start justify-between gap-6 sm:flex-row">
          <div className="flex items-center gap-2.5">
            <img src="/captionmotion-logo.png" alt="Caption Motion" className="h-8 w-8 rounded-lg object-contain" />
            <span className="font-display text-base font-black tracking-tight text-white">Caption Motion</span>
          </div>
          <nav className="flex flex-wrap gap-x-6 gap-y-2 text-sm text-[#A1A1AA]">
            <Link to="/pricing" className="transition-colors hover:text-white" data-testid="footer-pricing">Pricing</Link>
            <Link to="/contact" className="transition-colors hover:text-white" data-testid="footer-contact">Contact Us</Link>
            <Link to="/privacy" className="transition-colors hover:text-white" data-testid="footer-privacy">Privacy Policy</Link>
            <Link to="/terms" className="transition-colors hover:text-white" data-testid="footer-terms">Terms of Service</Link>
            <Link to="/refund" className="transition-colors hover:text-white" data-testid="footer-refund">Refund Policy</Link>
          </nav>
        </div>
        <div className="mt-8 border-t border-white/5 pt-6 text-xs leading-relaxed text-[#666]">
          <p>© {new Date().getFullYear()} Caption Motion. All rights reserved.</p>
          <p className="mt-2 max-w-3xl">
            You are responsible for ensuring you hold the necessary rights and permissions for any video, audio, fonts,
            images and other content you upload or generate. Caption Motion provides editing and animation tools and does
            not grant rights to third-party content.
          </p>
        </div>
      </div>
    </footer>
  );
}
